import { IButtonProps, IButtonStyles, IDatePickerStyles, IIconProps, ITextFieldStyles } from "@fluentui/react";

export const datePickerStyles: Partial<IDatePickerStyles> = { icon: { left: "4px", right: "unset" } };
export const textFieldStyles: Partial<ITextFieldStyles> = { suffix: { padding: "0 4px" }, field: { paddingLeft: "34px" } };
export const iconButtonStyles: Partial<IButtonStyles> = { root: { height: 'auto' }, icon: { fontSize: '12px' } };
export const iconButtonProps: IIconProps = { iconName: 'Clear' };
export const clearButtonProps: IButtonProps = { ariaLabel: 'Clear text' };